import { render, staticRenderFns } from "./detail01.vue?vue&type=template&id=55cc030e&scoped=true"
import script from "./detail01.vue?vue&type=script&lang=js"
export * from "./detail01.vue?vue&type=script&lang=js"
import style0 from "./detail01.vue?vue&type=style&index=0&id=55cc030e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cc030e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55cc030e')) {
      api.createRecord('55cc030e', component.options)
    } else {
      api.reload('55cc030e', component.options)
    }
    module.hot.accept("./detail01.vue?vue&type=template&id=55cc030e&scoped=true", function () {
      api.rerender('55cc030e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/DeliveryLoading/component/detail01.vue"
export default component.exports